import React, { useContext, useState, useEffect } from 'react';
import { Typography } from 'antd';
import { C } from 'jssip';
import cn from 'classnames';
import { sipPhoneStatuses } from '../../../../components/SipPhoneProvider';
import { sipStatusState } from '../../constants/sipStatusState';
import OnOffMicrophone from './components/OnOffMicrophone/OnOffMicrophone';
import DropCall from './components/DropCall/DropCall';
import Call from './components/Call/Call';
import NumPadBtn from './components/NumPadBtn/NumPadBtn';
import useSipStates from '../../../../hooks/useSipStates';
import { SipPhoneContext } from '../../../../components/SipPhoneProvider';
import styles from './Actions.module.scss';

const { CALL_STATUS_STARTING, CALL_STATUS_ACTIVE } = sipPhoneStatuses;

const Text = ({ text, strong, type, ...props }) => {
  return (
    <Typography.Text
      {...props}
      strong={strong}
      type={type}
      style={{ textAlign: 'center' }}
    />
  );
};

const Actions = ({ className }) => {
  const { sip, call } = useContext(SipPhoneContext);

  const { isConnected } = useSipStates();

  const [time, setTime] = useState(0);

  console.log(time);

  const isCallActive = call.status === CALL_STATUS_ACTIVE;

  useEffect(() => {
    let interval = null;
    if (isCallActive) {
      interval = setInterval(() => {
        setTime((time) => time + 1);
      }, 1000);
    } else if (!isCallActive && time !== 0) {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [isCallActive, time]);

  useEffect(() => {
    if (!isCallActive) {
      setTime(0);
    }
  }, [isCallActive]);

  const seconds = `0${time % 60}`.slice(-2);
  const minutes = `0${Math.floor(time / 60)}`.slice(-2);

  return (
    <div className={cn(styles.root, className)}>
      {!isConnected && <Text strong>{sipStatusState[sip.status].tooltip}</Text>}
      {call.status === CALL_STATUS_STARTING && <Text strong>Вызов...</Text>}
      {isCallActive && (
        <div className={styles.timerContainer}>
          <Text strong>Соединение с абонентом установлено</Text>
          <Text
            type={time > 40 ? 'danger' : undefined}
            strong
            className={styles.timer}
          >
            {minutes}:{seconds}
          </Text>
        </div>
      )}
      {call.error?.cause === C.causes.USER_DENIED_MEDIA_ACCESS && (
        <>
          <Text type="danger">Доступ к микрофону заблокирован.</Text>
          <Text type="danger">
            Чтобы совершать звонки, в настройках браузера разрешите доступ к
            микрофону для нашего приложения
          </Text>
        </>
      )}

      <div className={styles.wrapper}>
        <OnOffMicrophone />
        {isConnected && <NumPadBtn />}
        <Call />
        <DropCall />
      </div>
    </div>
  );
};

export default Actions;
